import { SPONSORS, PARTNERS, logoCardCls } from "@/lib/constants";
import { ExternalLink, Handshake, Instagram } from "lucide-react";

export default function PartnersSection() {
  return (
    <section data-testid="partners-section" className="max-w-7xl mx-auto px-4 my-14">
      <div className="flex items-center gap-3 mb-6">
        <span className="h-6 w-1.5 bg-legend-red" />
        <h2 className="font-display font-black uppercase text-2xl md:text-3xl tracking-wide">Pubblicità & Partner Ufficiali</h2>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {SPONSORS.map((s) => (
          <a
            key={s.name}
            href={s.url}
            target="_blank"
            rel="noreferrer"
            data-testid={`partner-logo-${s.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            title={s.name}
            className={`group flex items-center justify-center rounded-sm p-4 h-28 hover:border-legend-red hover:shadow-lg transition-all ${logoCardCls(s.name)}`}
          >
            <img src={s.logo} alt={s.name} className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform" />
          </a>
        ))}
      </div>

      {/* Team partners */}
      <div className="mt-6 grid sm:grid-cols-2 gap-4">
        {PARTNERS.map((p) => (
          <div key={p.name} className="rounded-sm bg-legend-ink text-white flex items-center gap-5 p-6" data-testid={`team-partner-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <img src={p.logo} alt={p.name} className="h-20 w-20 object-contain rounded-full bg-black shrink-0" />
            <div className="flex-1 min-w-0">
              <span className="inline-flex items-center gap-2 text-legend-yellow font-mono uppercase text-[10px] tracking-widest mb-1"><Handshake size={12} /> {p.role || "Team Partner"}</span>
              <h3 className="font-display font-black uppercase text-xl leading-tight">{p.name}</h3>
              <p className="text-slate-300 text-xs">{p.tagline}</p>
            </div>
            <a href={p.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 bg-legend-red hover:bg-legend-dark text-white text-sm font-bold uppercase px-4 py-2 rounded-sm transition-colors shrink-0">
              <Instagram size={15} /> <span className="hidden sm:inline">Seguili</span>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
